export enum TrackDomain {
    ArboPark = "arbopark",
    bomboclaat = "bomboclaat",
}
